// extracted by mini-css-extract-plugin
export default {"action-button":"MultipleDownloadButton_action-button__cvALH","spinner":"MultipleDownloadButton_spinner__wozzY","has-activity":"MultipleDownloadButton_has-activity__hrIx7"};